import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import InputField from 'yoda-checkout-components/lib/components/CustomTags/InputField/InputField';
import Constants from '../../utility/Constants';
import giftCardUtility from '../../utility/giftCardUtility';

export class Card extends Component {
    static defaultProps = {
        value: '',
        error: '',
    };

    static propTypes = {
        value: PropTypes.string,
        error: PropTypes.string,
        onChange: PropTypes.func.isRequired,
    };

    constructor() {
        super();
        this.onChange = this.handleChange.bind(this);
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.value !== nextProps.value || this.props.error !== nextProps.error) {
            return true;
        }
        return false;
    }

    handleChange(value, event) {
        event.preventDefault();
        if (giftCardUtility.cardInputCheck(event) || giftCardUtility.isTargetValueEmpty(event)) {
            this.props.onChange(...giftCardUtility.createCardEventProps(event));
        }
    }

    render() {
        return (
            <InputField
                name={Constants.labelGC}
                id={Constants.labelGC}
                automationId="at-giftcard-text-field"
                errorAutomationId="at-giftcard-num-form-error"
                value={this.props.value}
                onChange={this.onChange}
                onBlur={this.onChange}
                placeholder={Constants.labelGC}
                hasError={!isEmpty(this.props.error)}
                errorMsg={this.props.error}
                dataQmBlock
                datatlPrivate
                infoIconTooltipPlacement="Right"
                infoIconTooltipDirection="Bottomright"
                    // eslint-disable-line
                infoIconTooltipMessage={
                    <span dangerouslySetInnerHTML={{ __html: Constants.toolTipcard }} />
                }
            />
        );
    }
}

export default Card;
